import { defineStore } from 'pinia'

const getCoinList = (payload) => {
  return Array.isArray(payload) ? payload : []
}

const useQuotesStore = defineStore('quotesStore', {
  state: () => ({
    coins: [],
    coinsLoaded: false,
  }),
  getters: {
    coinMap: (state) => {
      return state.coins.reduce((map, coin) => {
        if (coin?.coinName) {
          map[String(coin.coinName).toUpperCase()] = coin
        }
        return map
      }, {})
    },
    getCoinProp () {
      return (coinName, propKey, fallback = '') => {
        const coin = this.coinMap[String(coinName || '').toUpperCase()]
        return coin && coin[propKey] !== undefined && coin[propKey] !== null ? coin[propKey] : fallback
      }
    },
  },
  actions: {
    async getCoins (options = {}) {
      if (!options.force && this.coinsLoaded) {
        return this.coins
      }
      const req = configApi.coinInfo({}, { immediate: false })
      await req.execute()
      this.coins = getCoinList(req.data.value?.data)
      this.coinsLoaded = true
      return this.coins
    },
    getCoinIcon (coinName) {
      return this.getCoinProp(coinName, 'iconUrl')
    },
  },
})

export default useQuotesStore
